<template>
  <div class="index-outer">
    <myheader></myheader>
    <div class="Pindex">
      <!-- <div class="nav">
        <div :class="navIndex == 0 ? 'active' : ''" @click="navIndex = 0">
          个人预约
        </div>
        <div :class="navIndex == 1 ? 'active' : ''" @click="navIndex = 1">
          团队预约
        </div>
      </div> -->

      <div v-if="type != 3">
        <div class="stitle">讲解方式</div>

        <el-radio-group
          v-model="ruleForm.explained"
          @change="getTimeList"
          style="padding-bottom: 20px"
        >
          <el-radio :label="0">馆方讲解</el-radio>
          <el-radio :label="1">持证讲解</el-radio>
          <el-radio :label="2">无需讲解</el-radio>
        </el-radio-group>
        <div v-if="ruleForm.explained == 0" class="jiangjie">
          1、申请成功的团队由馆方在接待当天安排具体讲解员，团队无法指定；
        </div>
        <div v-if="ruleForm.explained == 0" class="jiangjie">
          2、讲解接待保留时间为15分钟，超过15分钟抵达团队将取消讲解服务。
        </div>
        <div v-else-if="ruleForm.explained == 1" class="jiangjie">
          钱馆为有自行讲解需求的团队开展讲解培训，考核通过自动进入“志愿讲解员”数据库，可上传身份信息与证书申请自行讲解，详见“<span
            style="color: red"
            >钱学森图书馆规范展厅讲解管理办法</span
          >”。
        </div>
      </div>
      <div v-else-if="type == 3">
        <div class="stitle">选择讲座</div>
        讲座名称
        <el-select
          v-model="ruleForm.teamId"
          placeholder=""
          prop="sj"
          required="true"
        >
          <el-option
            v-for="item in sjoptions1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- <div v-if="ruleForm.explained==0">
              1、申请成功的团队由馆方在接待当天安排具体讲解员，团队无法指定；
          
            </div>
            <div v-if="ruleForm.explained==0">
              2、讲解接待保留时间为15分钟，超过15分钟抵达团队将取消讲解服务。
            </div>
            <div v-else-if="ruleForm.explained==1">
              钱馆为有自行讲解需求的团队开展讲解培训，考核通过自动进入“志愿讲解员”数据库，可上传身份信息与证书申请自行讲解，详见“<span style="color:red">钱学森图书馆规范展厅讲解管理办法</span>”。
            </div> -->
      </div>
      <div class="calendar">
        <div class="calendar-nav">
          <div
            v-for="(item, index) in calendarNav"
            :key="index"
            class="calendar-nav-item"
          >
            <div class="calendar-nav-item-num">{{ item.num }}</div>
            <div class="calendar-nav-item-English">{{ item.English }}</div>
          </div>
        </div>
        <div class="calendar-data">
          <div
            v-for="(item, index) in calendarData"
            :key="index"
            class="calendar-data-item"
          >
            <div v-if="item.type == 'no'" class="calendar-noactive">
              <div>{{ getoverdue(item.date) }}</div>
              <div style="font-size: 14px">不可预约</div>
            </div>
            <div v-if="item.type < 0" class="calendar-noactive">
              <div>{{ getoverdue(item.date) }}</div>
              <div style="font-size: 14px">闭馆</div>
            </div>
            <div v-if="item.type == 0" class="calendar-noactive">
              <div>{{ getoverdue(item.date) }}</div>
              <div style="font-size: 14px">无票</div>
            </div>
            <div
              v-if="item.type > 0"
              :class="calendarDate == item.date ? 'selected' : ''"
              class="calendar-active"
              @click="calendarDate = item.date"
            >
              <div>{{ getoverdue(item.date) }}</div>
              <div style="font-size: 14px">有票</div>
            </div>
          </div>
        </div>
        <div class="stitle">时段选择</div>
        <div class="calendar-data">
          <div
            v-for="(item, index) in timeData"
            :key="index"
            class="calendar-data-item"
          >
            <div v-if="item.show == 1" class="calendar-noactive">
              <div>{{ item.start }}-{{ item.end }}</div>
              <div style="font-size: 14px">已过期</div>
              <!-- <div style="font-size: 14px">批次{{ item.leftQuantity }}</div> -->
            </div>
            <div v-if="item.show == 2" class="calendar-noactive">
              <div>{{ item.start }}-{{ item.end }}</div>
              <div style="font-size: 14px">无票</div>
            </div>
            <div
              v-if="item.show == 3"
              :class="timeIndex == index + 1 ? 'selected' : ''"
              class="calendar-active"
              @click="timeIndex = index + 1"
            >
              <div>{{ item.start }}-{{ item.end }}</div>
              <div style="font-size: 14px">有票</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="navIndex == 0">
        <div class="stitle" style="margin-bottom: 30px">填写游客信息</div>
        <el-form class="demo-ruleForm" abel-width="70px">
          <div v-for="(item, index) in userList" :key="index" class="user">
            <div style="color: #aa2020; margin-bottom: 7px">
              游客{{ index + 1 }}
              <i
                class="el-icon-circle-close"
                v-if="index != 0"
                @click="deleteUser(index)"
              ></i>
            </div>
            <el-form-item prop="name" label="姓名">
              <el-input
                v-model="item.name"
                placeholder="请填写游客姓名"
              ></el-input
            ></el-form-item>
            <el-form-item prop="phone" label="手机号">
              <el-input
                v-model="item.phone"
                placeholder="请填写手机号"
              ></el-input
            ></el-form-item>
            <el-form-item prop="identity" label="身份证">
              <el-input
                v-model="item.identity"
                placeholder="请填写身份证"
              ></el-input
            ></el-form-item>
          </div>
        </el-form>
        <div class="user-add" @click="addUser" style="width: 65.75px">
          添加游客
        </div>
        <div class="sumbit" @click="sumbitUser">立即预约</div>
      </div> -->
      <div v-if="navIndex == 1">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="stitle">团队信息</div>

          <el-form-item label="团队名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入团队名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="参观人数" prop="num">
            <el-input-number
              v-model="ruleForm.num"
              :placeholder="this.num"
              :min="this.min"
              :max="this.max"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="联系人姓名" prop="leader">
            <el-input
              v-model="ruleForm.leader"
              placeholder="请输入联系人姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系人手机" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入联系人手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="团队类型" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择团队类型">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团队来源" prop="area">
            <el-select v-model="ruleForm.area" placeholder="请选择来源地">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="团队年龄段" required="true">
            <el-input v-model="ruleForm.adult" prop="adult">
              <template slot="prepend">成年人</template>
              <template slot="append">位</template></el-input
            >
            <el-input v-model="ruleForm.child" prop="child">
              <template slot="prepend">未成年人</template>
              <template slot="append">位</template></el-input
            >
          </el-form-item>
          <div v-if="ruleForm.explained == 1">
            <div class="stitle">自行讲解信息</div>

            <el-form-item label="讲解员姓名" prop="jjName">
              <el-input v-model="ruleForm.jjName" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="讲解员手机" prop="jjPhone">
              <el-input v-model="ruleForm.jjPhone"></el-input>
            </el-form-item>

            <el-form-item label="证书上传" prop="zhengshu">
              <el-upload
                class="upload-demo"
                :action="uploadFileApi"
                accept=".jpg,.jpeg,.png,.pdf"
                :on-success="zshandSuccess"
                :before-remove="beforeRemove"
                :on-error="beforeError"
                :before-upload="beforeAvatarUpload"
                ref="upload"
                :multiple="false"
                :limit="1"
                :file-list="fileList"
              >
                <div class="user-add" slot="trigger">
                  {{ "上传文件" }}
                </div>
                <div style="color: grey">
                  只能上传jpg/png/pdf文件，且不超过5M
                </div>
                <!-- <div style="color: #409eff; cursor: pointer" @click="mydownload">
                <img src="../assets/download.png" alt="" width="12px" />
               公函模版下载
              </div> -->
              </el-upload>
              <!-- <div>
              无公函序厅统讲，由钱馆讲解员在钱馆序厅为团队全体参观者做总体介绍，随后团队在领队带领下自行参观，参观过程中不得解散队伍
            </div> -->
            </el-form-item>
          </div>
          <div class="stitle">文件上传</div>
          <el-form-item label="承诺书" prop="chengnuo">
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              accept=".jpg,.jpeg,.png,.pdf"
              ref="upload"
              :multiple="false"
              :before-remove="beforeRemove"
              :on-error="beforeError"
              :before-upload="beforeAvatarUpload"
              :on-success="cnshandSuccess"
              :limit="1"
              :file-list="fileList"
            >
              <div class="user-add" slot="trigger">
                {{ "上传文件" }}
              </div>
              <div style="color: #409eff; cursor: pointer" @click="mydownload">
                <img src="../assets/download.png" alt="" width="12px" />
                承诺书模版下载
              </div>
            </el-upload>
            <div style="color: grey">只能上传jpg/png/pdf文件，且不超过5M</div>
          </el-form-item>
          <div v-if="type != 0">
            <el-form-item label="公函上传" prop="gonghan">
              <el-upload
                class="upload-demo"
                :action="uploadFileApi"
                accept=".jpg,.jpeg,.png,.pdf"
                ref="upload"
                :multiple="false"
                :before-remove="beforeRemove"
                :on-error="beforeError"
                :before-upload="beforeAvatarUpload"
                :on-success="ghhandSuccess"
                :limit="1"
                :file-list="fileList"
              >
                <div class="user-add" slot="trigger">
                  {{ "上传文件" }}
                </div>
              </el-upload>
              <div style="color: grey">只能上传jpg/png/pdf文件，且不超过5M</div>
              <div v-if="type != 3">
                无公函序厅统讲，由钱馆讲解员在钱馆序厅为团队全体参观者做总体介绍，随后团队在领队带领下自行参观，参观过程中不得解散队伍
              </div>
            </el-form-item>
          </div>
          <!-- <div class="stitle">是否需要场地</div> -->

          <el-form-item label="备注">
            <el-input type="textarea" v-model="ruleForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="sumbit" @click="sumbitUser" v-if="!Addloading">
          {{ ruleForm.id ? "立即修改" : "立即预约" }}
        </div>
        <div class="sumbit" v-else>提交中</div>
      </div>
    </div>
  </div>
</template>
<script>
import myheader from "../components/myheader.vue";
import { dateFormat } from "../utils";
export default {
  data() {
    return {
      uploadFileApi:
        "https://" + process.env.VUE_APP_BASE_API + "/travel/oss/upload",
      Addloading: false,
      navIndex: 1, //0个人预约，1团队预约
      calendarNav: [
        { num: "周一", English: "MON" },
        { num: "周二", English: "TUE" },
        { num: "周三", English: "WED" },
        { num: "周四", English: "THU" },
        { num: "周五", English: "FRI" },
        { num: "周六", English: "SAT" },
        { num: "周七", English: "SUN" },
      ],
      options: [
        {
          value: "上海市",
          label: "上海市",
        },
        {
          value: "外省市",
          label: "外省市",
        },
        {
          value: "境外",
          label: "境外",
        },
      ],
      //日期选择和日期列表
      calendarDate: "",
      calendarData: [],
      type: 0,
      delete: 0,
      num: "20-50人",
      min: 20,
      max: 50,
      id: "",
      //时间段选择和时间段列表
      timeIndex: "",
      timeData: [],
      //预约游客
      userList: [
        {
          name: "",
          phone: "",
          identity: "",
        },
      ],
      //团队表格
      fileList: [],
      //团队预约字段
      ruleForm: {
        tourId: "101473961237549056",
        name: "",
        appointDate: "",
        appointTimeStart: "",
        appointTimeEnd: "",
        classification: "",
        type: "",
        leader: "",
        phone: "",
        identity: "",
        file: "",
        child: 0,
        adult: 0,
        explained: 0,
        needSpace: 0,
        remark: "",
        gonghan: "",
        chengnuo: "",
        zhengshu: "",
      },
      //闭馆
      disableDate: "",
      disableWeek: [],
      Daylist: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 0,
          label: "周日",
        },
      ],
      sjoptions1: [
        {
          value: 0,
          label: "钱学森精神宣讲（60分钟）",
        },
        {
          value: 1,
          label: "微党课（15分钟）",
        },
        // {
        //   value: 2,
        //   label: "钱学森回国前后的经济收入之考察",
        // },
        // {
        //   value: 3,
        //   label: "走进中国科学家的精神世界",
        // },
        // {
        //   value: 4,
        //   label: "藏品中的科学家精神",
        // },
        // {
        //   value: 5,
        //   label: "钱学森与上海交通大学",
        // },
        // {
        //   value: 6,
        //   label: "国难思良将——杰出的战略科学家钱学森",
        // },
        // {
        //   value: 7,
        //   label: "钱学森的艰难归国之路",
        // },
        // {
        //   value: 8,
        //   label: "从人生选择中探索钱学森的成长故事",
        // },
        // {
        //   value: 9,
        //   label: "共产党员钱学森",
        // },
      ],

      //特殊日期和特殊周时间段配置
      OpenTimesDay: [],
      OpenTimesWeek: [],
      //团队字段校验规则
      rules: {
        appointDate: [
          { required: true, message: "请选择日预约期", trigger: "blur" },
        ],
        appointTimeEnd: [
          { required: true, message: "请选择预约时间段", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入团队名称", trigger: "blur" }],
        jjName: [
          { required: true, message: "请输入讲解员名称", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入团队人数", trigger: "blur" }],
        leader: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        sj: [{ required: true, message: "请选择讲座", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系人手机号", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        jjPhone: [
          { required: true, message: "请输入讲解员手机号", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        type: [{ required: true, message: "请选择团队类型", trigger: "blur" }],
        area: [{ required: true, message: "请选择团队来源", trigger: "blur" }],
        file: [
          { required: true, message: "请上传团队人员名单", trigger: "blur" },
        ],
        explained: [
          { required: true, message: "请选择是否需要讲解", trigger: "blur" },
        ],
        needSpace: [
          { required: true, message: "请选择是否需要场地", trigger: "blur" },
        ],
      },
      //团队类型
      options1: [
        {
          value: 0,
          label: "政府",
        },
        {
          value: 1,
          label: "国企",
        },
        {
          value: 2,
          label: "民营",
        },
        {
          value: 3,
          label: "外资合资",
        },
        {
          value: 4,
          label: "事业单位",
        },
        {
          value: 5,
          label: "大中小学",
        },
        {
          value: 6,
          label: "医院",
        },
        {
          value: 7,
          label: "其他",
        },
      ],
    };
  },
  components: {
    myheader,
  },
  watch: {
    //预约日期改变
    calendarDate(val) {
      this.timeIndex = "";
      if (val) {
        this.getTimeList();
      } else {
        this.timeData = [];
      }
    },
    navIndex() {
      this.timeIndex = "";
      this.myload();
    },
  },

  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      console.log(this.type);
    }

    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      console.log(this.id);
    }
    this.$nextTick(() => {
      switch (this.type) {
        case "0":
          this.num = "20-50人";
          this.min = 20;
          this.max = 50;
          break;
        case "1":
          this.num = "20-99人";
          this.min = 20;
          this.max = 99;
          break;
        case "2":
          this.num = "大于100人";
          this.min = 100;
          this.max = 9999;
          break;
        case "3":
          this.num = "20-50人";
          this.min = 20;
          this.max = 50;
          break;
      }
    });
    if (this.$route.query.id) {
      this.ruleForm.id = this.$route.query.id;
      this.navIndex = 1;
      this.$axios.get("/book/detail?id=" + this.ruleForm.id).then((res) => {
        this.ruleForm = res.data;

        this.type = this.ruleForm.classification;
        this.calendarDate = this.ruleForm.appointDate;

        //  this.timeIndex=this.timeData.filter(item=>item.start==this.ruleForm.appointTimeStart)
        //  this.timeData[this.timeIndex - 1]["start"] =this.ruleForm.appointTimeStart ;
        // this.timeData[this.timeIndex - 1]["end"] = this.ruleForm.appointTimeEnd;
        this.myload();
      });
    } else {
      this.myload();
    }
  },
  methods: {
    numput() {
      if (this.type == 0) {
        if (this.num < 20) {
          this.num = 20;
        }
      }
    },
    // eslint-disable-next-line
    beforeRemove(file, fileList) {
      if (this.delete == 0) {
        return this.$confirm(`确定移除 ${file.name}？`);
      }
      this.delete = 0;
    },
    myload() {
      this.$axios
        .get(
          `/book/tourInfo/101473961237549056?explained=` +
            this.ruleForm.explained
        )
        .then((res) => {
          //获取特殊周和特殊日期的时间段
          let OpenTimesDay =
            (this.type != 3
              ? res.data.bookOpenTimesSpecialDay
              : res.data.bookOpenTimesSpecialDayTeam) || [];
          let OpenTimesWeek =
            (this.type != 3
              ? res.data.bookOpenTimesSpecialWeek
              : res.data.bookOpenTimesSpecialWeekTeam) || [];
          this.OpenTimesDay = [
            ...new Set(OpenTimesDay.map((item) => item.typeValue)),
          ];

          this.OpenTimesWeek = [
            ...new Set(OpenTimesWeek.map((item) => item.typeValue)),
          ].map((item) => Number(item));

          //获取景点禁止预约日期
          if (res.data.bookTour.disableDate) {
            this.disableDate = JSON.parse(res.data.bookTour.disableDate);
          }
          //获取景点禁止预约周几
          if (res.data.bookTour.disableWeek) {
            let disableWeek = JSON.parse(res.data.bookTour.disableWeek);
            let data = [];
            for (const element of disableWeek) {
              for (const myval of this.Daylist) {
                if (element == myval.label) {
                  data.push(myval.value);
                  break;
                }
              }
            }
            this.disableWeek = data;
          }
          //闭馆时间顺延下一天，生成num天的可预约时间
          let datelist1 = [];
          let datelist2 = [];
          let num = res.data.bookTour.date;
          let num1 = res.data.bookTour.startDate;
          let mys = 24 * 60 * 60 * 1000;
          if (
            num == 0 ||
            res.data.bookTour.status == 1 ||
            this.disableWeek.length == 7
          ) {
            this.$alert("该场所已关闭预约", "提醒", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `action: ${action}`,
                });
              },
            });
          } else {
            for (let i = num1; datelist1.length < num - num1; i++) {
              let date = new Date(new Date().getTime() + mys * i);
              let mytime = dateFormat("YYYY-mm-dd", date);
              if (
                this.OpenTimesWeek.indexOf(new Date(mytime).getDay()) != -1 ||
                this.OpenTimesDay.indexOf(mytime) != -1
              ) {
                datelist1.push({
                  date: mytime,
                  type: 1,
                  index: i,
                });
              } else {
                if (
                  this.disableWeek.indexOf(new Date(mytime).getDay()) == -1 &&
                  this.disableDate.indexOf(mytime) == -1
                ) {
                  datelist1.push({
                    date: mytime,
                    type: 1,
                    index: i,
                  });
                } else {
                  datelist2.push({
                    date: mytime,
                    type: 3,
                    index: i,
                  });
                }
              }
            }
          }
          let arr = [...datelist1, ...datelist2];
          function compare(propertyName) {
            return function (object1, object2) {
              var value1 = object1[propertyName];
              var value2 = object2[propertyName];
              if (value1 < value2) {
                return -1;
              } else if (value1 > value2) {
                return 1;
              } else {
                return 0;
              }
            };
          }
          let calendarData = arr.sort(compare("index"));
          let type = 0;
          if (this.type == 3) {
            type = 1;
          }
          //查询生成的日期列表余票状态
          this.$axios
            .get(
              `/book/openDate?startDate=${calendarData[0].date}&endDate=${
                calendarData[calendarData.length - 1].date
              }&tourId=101473961237549056&type=` + type
            )
            .then((res) => {
              calendarData = res.data;
              let item = new Date(calendarData[0].date).getDay();
              let noDateList = [];
              if (item != 0) {
                item = item - 1;
              } else {
                item = 6;
              }
              //过期的日期//补齐列表的周数
              for (item; item > 0; item--) {
                let date = new Date(new Date().getTime() + mys * -item);
                let mytime = dateFormat("YYYY-mm-dd", date);
                noDateList.push({
                  date: mytime,
                  type: "no", //不可预约
                });
              }
              this.calendarData = [...noDateList, ...calendarData];
              if (!this.ruleForm.id) {
                //获取第一个可预约的日期
                this.calendarDate = this.calendarData.find(
                  (item) => item.type > 1
                )
                  ? this.calendarData.find((item) => item.type > 1).date
                  : null;
                this.getTimeList();
              } else {
                this.calendarDate = this.ruleForm.appointDate;
              }
            });
        });
    },
    // eslint-disable-next-line
    beforeError(err, file, fileList) {
      return this.$confirm(
        "文件上传失败，请确认文件大小或格式是否符合上传要求"
      );
    },

    beforeAvatarUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "jpg", "jpeg", "png"];

      const isLt500k = file.size / 1024 / 1024 < 5;
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.delete = 1;
        this.$confirm(`文件上传失败，请确认文件格式是否符合上传要求`);
        // this.$message.error("上传图片只能是jpg,jpeg,png,pdf 格式!");
        return false;
      }
      if (!isLt500k) {
        this.delete = 1;
        this.$confirm(`文件上传失败，请确认文件大小是否符合上传要求`);
        //this.$message.error("上传图片大小不能超过 5m!");
        return false;
      }
    },
    // eslint-disable-next-line
    cnshandSuccess(response, file, fileList) {
      this.ruleForm.chengnuo = response.data.url;
    },

    // eslint-disable-next-line
    ghhandSuccess(response, file, fileList) {
      this.ruleForm.gonghan = response.data.url;
    },
    // eslint-disable-next-line
    zshandSuccess(response, file, fileList) {
      console.log(this.ruleForm);
      this.ruleForm.zhengshu = response.data.url;
    },

    //获取开放时间
    getTimeList() {
      this.$axios
        .get(
          `/book/tourInfo/101473961237549056/?date=${this.calendarDate}&&explained=${this.ruleForm.explained}`
        )
        .then((res) => {
          let ALLtimelist;
          let bookOpenTimesSpecialDay =
            (this.type != 3
              ? res.data.bookOpenTimesSpecialDay
              : res.data.bookOpenTimesSpecialDayTeam) || [];
          let bookOpenTimesSpecialWeek =
            (this.type != 3
              ? res.data.bookOpenTimesSpecialWeek
              : res.data.bookOpenTimesSpecialWeekTeam) || [];
          if (this.OpenTimesDay.indexOf(this.calendarDate) != -1) {
            ALLtimelist = bookOpenTimesSpecialDay.filter(
              (item) => item.typeValue == this.calendarDate
            );
          } else if (
            this.OpenTimesWeek.indexOf(new Date(this.calendarDate).getDay()) !=
            -1
          ) {
            ALLtimelist = bookOpenTimesSpecialWeek.filter(
              (item) => item.typeValue == new Date(this.calendarDate).getDay()
            );
          } else {
            ALLtimelist =
              this.type != 3
                ? res.data.bookOpenTimes
                : res.data.bookOpenTimesTeam;
          }
          for (let iterator of ALLtimelist) {
            if (this.getoverdue1(iterator.end)) {
              this.$set(iterator, "show", 1); //时间段是否过期
            } else {
              if (iterator.leftQuantity == 0 && iterator.limitCount != -1) {
                this.$set(iterator, "show", 2); //余票是否为0
              } else {
                this.$set(iterator, "show", 3); //正常状态可选择
              }
            }
          }
          // if (!this.ruleForm.id) {
          //   this.timeIndex =
          //     ALLtimelist.findIndex((item) => item.show == 3) + 1;
          // }

          this.timeData = ALLtimelist;
          // console.log(this.timeData);
            this.timeData.filter(
              (item,index) => {
                 if(item.start == this.ruleForm.appointTimeStart){
                  this.timeIndex = index+1
                  return index
                 }
               
              }
            )
        });
    },
    compare(obj1, obj2) {
      var val1 = obj1["index"];
      var val2 = obj2["index"];
      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    },
    //上传团队表单
    uploadFile(param) {
      let fileObj = param.file; // 相当于input里取得的files
      this.$set(this.ruleForm, "file", fileObj);
    },
    //添加游客
    addUser() {
      this.userList.push({
        name: "",
        phone: "",
        identity: "",
      });
    },
    //删除游客
    deleteUser(index) {
      this.$delete(this.userList, index);
    },
    //个人预约的提交
    sumbitUser() {
      if (!this.calendarDate) {
        this.$message.error("未选择日期");
        return false;
      }
      if (!this.timeIndex) {
        this.$message.error("未选择时段");
        return false;
      }
      if (!this.ruleForm.chengnuo) {
        this.$message.error("未上传承诺书");
        return false;
      }
      if (!this.ruleForm.num) {
        this.$message.error("未输入人数");
        return false;
      }
      // for (const iterator of this.userList) {
      //   for (const key in iterator) {
      //     if (!iterator[key]) {
      //       this.$message.error("游客信息请填完整");
      //       return false;
      //     }
      //   }
      // }
      let datalist = [];
      this.ruleForm.classification = this.type;
      this.ruleForm.appointDate = this.calendarDate;
      this.ruleForm.appointTimeStart =
        this.timeData[this.timeIndex - 1]["start"];
      this.ruleForm.appointTimeEnd = this.timeData[this.timeIndex - 1]["end"];

      datalist.push(this.ruleForm);
      console.log(datalist);
      // this.userList.forEach((element) => {
      //   datalist.push({
      //     tourId: "101473961237549056",
      //     name: element.name,
      //     phone: element.phone,
      //     identity: element.identity,
      //     appointDate: this.calendarDate,
      //     appointTimeStart: this.timeData[this.timeIndex - 1]["start"],
      //     appointTimeEnd: this.timeData[this.timeIndex - 1]["end"],
      //   });
      // });
      if (this.ruleForm.id) {
        this.$axios
          .post("/book/admin/appointment/update", this.ruleForm)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              this.$router.push("/PorderCenter?typeIndex=0");
            }
          });
      } else {
        this.$axios.post("/book/appointment", datalist).then((res) => {
          if (res.code == 200) {
            this.$message.success("预约成功");
            this.$router.push("/PorderCenter?typeIndex=0");
          }
        });
      }
    },
    //团队预约的提交
    submitTeam(formName) {
      this.$refs[formName].validate((valid) => {
        if (!this.calendarDate) {
          this.$message.error("未选择日期");
          return false;
        }
        if (!this.timeIndex) {
          this.$message.error("未选择时段");
          return false;
        }
        this.ruleForm.appointDate = this.calendarDate;
        this.ruleForm.appointTimeStart =
          "2022-02-12 " + this.timeData[this.timeIndex - 1]["start"];
        this.ruleForm.appointTimeEnd =
          "2022-02-12 " + this.timeData[this.timeIndex - 1]["end"];
        if (valid) {
          this.Addloading = true;
          let team = { ...this.ruleForm };
          this.$delete(team, "file");
          let fd = new FormData();
          fd.append("file", this.ruleForm.file); // 文件对象
          fd.append("team", JSON.stringify(team));
          let url;
          if (this.ruleForm.id) {
            url = "/team/resubmit";
          } else {
            url = "/team/enrol";
          }
          this.$axios.post(url, fd).then((res) => {
            this.Addloading = false;
            if (res.code == 200) {
              if (!this.ruleForm.id) {
                this.ruleForm = {
                  tourId: "101473961237549056",
                  name: "",
                  appointDate: "",
                  appointTimeStart: "",
                  appointTimeEnd: "",
                  type: "",
                  leader: "",
                  phone: "",
                  identity: "",
                  file: "",
                  explained: 0,
                  needSpace: 0,
                  remark: "",
                };
                this.fileList = [];
              }
              this.$message.success("操作成功");
              this.$router.push("/PorderCenter?typeIndex=1");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    getoverdue(value) {
      return dateFormat("mm月dd日", new Date(value));
    },
    //判断预约时间段是否过期
    getoverdue1(val) {
      let valitem =
        new Date(`${this.calendarDate} ${val}:00`).getTime() ||
        new Date(
          `${this.calendarDate} ${val}:00`.replace(/-/g, "/")
        ).getTime() ||
        new Date(`${this.calendarDate}T${val}:00`).getTime();
      if (new Date().getTime() > valitem) {
        return true;
      } else {
        return false;
      }
    },
    mydownload() {
      window.location.href =
        "https://ar-travel-file.1jiaohu.com/%E9%92%B1%E5%AD%A6%E6%A3%AE%E5%9B%BE%E4%B9%A6%E9%A6%86%E5%9B%A2%E4%BD%93%E5%8F%82%E8%A7%82%E5%AE%89%E5%85%A8%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf";
    },
  },
};
</script>
<style scoped lang="less">
.jiangjie {
  font-weight: 1000;
  color: red;
}
.Pindex {
  width: 820px;
  margin: 0 auto;
  padding-bottom: 100px;
  font-size: 16px;
  .stitle {
    color: rgb(85, 85, 85);
    font-family: Noto Sans SC;
    font-size: 18px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .nav {
    margin-top: 40px;
    display: flex;
    div {
      width: 140px;
      line-height: 42px;
      border: 1px solid rgb(132, 132, 132);
      border-radius: 27.5px;
      color: #848484;
      text-align: center;
      margin-right: 20px;
      cursor: pointer;
    }
    .active {
      border: 1px solid rgb(170, 32, 32);
      border-radius: 27.5px;
      color: #aa2020;
    }
  }
  .calendar {
    margin-top: 40px;
    margin-bottom: 20px;
    .calendar-nav {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .calendar-nav-item {
        color: #aa2020;
        font-weight: 600;
        width: 105px;
        text-align: center;
      }
    }
    .calendar-data {
      display: flex;
      flex-wrap: wrap;
      //   justify-content: space-between;
      .calendar-data-item {
        color: #aa2020;
        width: 105px;
        margin-right: 12px;
        text-align: center;
        margin-bottom: 20px;
        .selected {
          background-color: #aa2020 !important;
          color: #ffffff !important;
        }
        .calendar-active {
          background-color: #fff1e2;
          color: #555555;
          border: 1px solid rgb(170, 32, 32);
          padding: 7px 0;
          cursor: pointer;
        }
        .calendar-noactive {
          background-color: rgb(255, 255, 255);
          border: 1px solid rgba(0, 0, 0, 0.19);
          padding: 7px 0;
          color: rgba(85, 85, 85, 0.3);
        }
      }
    }
  }
  .user {
    width: 320px;
    position: relative;
    margin-top: 20px;
    .el-form-item {
      margin-bottom: 5px;
    }
    i {
      position: absolute;
      right: 0;
      top: 0px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .user-add {
    // width: 65.75px;
    padding: 0 10px;
    border: 1px dashed rgb(170, 32, 32);
    border-radius: 3px;
    color: #aa2020;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
    cursor: pointer;
    //margin-top: 40px;
  }
  .sumbit {
    width: 322px;
    line-height: 48.5px;
    background: rgb(170, 32, 32);
    border-radius: 5px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    margin-top: 30px;
    cursor: pointer;
  }
}
</style>